import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/templates/')({
	component: () => (
		<Navigate
			to='/p/templates/$template_id'
			params={{ template_id: 'scenario' }}
			replace
		/>
	),
})
